(function () {
  const CART_SHARE_PARAM = 'cart_share';

  function parseSharedCart(/** @type {string} */ value) {
    if (!value || typeof value !== 'string') return [];
    /** @type {{ id: number; quantity: number }[]} */
    const items = [];
    const pairs = value.split(',');
    for (const pair of pairs) {
      const colonIndex = pair.indexOf(':');
      if (colonIndex === -1) continue;
      const idStr = pair.slice(0, colonIndex).trim();
      const qtyStr = pair.slice(colonIndex + 1).trim();
      const id = parseInt(idStr, 10);
      const qtyMatch = qtyStr.match(/^\d+/);
      const quantity = qtyMatch ? parseInt(qtyMatch[0], 10) : 1;
      if (id && quantity > 0) items.push({ id, quantity });
    }
    return items;
  }

  function showBanner(/** @type {{ id: number; quantity: number }[]} */ items) {
    const banner = document.getElementById('cart-share-banner');
    const textEl = banner?.querySelector('[data-cart-share-text]');
    if (!banner || !textEl) return;
    const count = items.length;
    const suffix = count === 1 ? 'item' : 'items';
    const msg = banner.dataset.sharedMessage || `Someone shared a cart with you (${count} ${suffix}).`;
    textEl.textContent = msg.replace(/\{\{\s*count\s*\}\}/g, String(count));
    banner.classList.remove('hidden');
    banner.hidden = false;
  }

  function hideBanner() {
    const banner = document.getElementById('cart-share-banner');
    if (!banner) return;
    banner.classList.add('hidden');
    banner.hidden = true;
  }

  function getCartUrlWithoutParam() {
    const url = new URL(window.location.href);
    url.searchParams.delete(CART_SHARE_PARAM);
    return url.toString();
  }

  function getCartAddUrl() {
    if (typeof Theme !== 'undefined' && Theme.routes?.cart_add_url) return Theme.routes.cart_add_url;
    if (typeof window.Shopify !== 'undefined' && window.Shopify.routes?.root) {
      return window.Shopify.routes.root + 'cart/add.js';
    }
    return '/cart/add.js';
  }

  function addSharedToCart(/** @type {{ id: number; quantity: number }[]} */ items) {
    const addUrl = getCartAddUrl();
    const banner = document.getElementById('cart-share-banner');
    const textEl = banner?.querySelector('[data-cart-share-text]');
    const addingLabel = banner?.dataset.addingLabel || 'Adding…';
    const addLabel = banner?.dataset.addLabel || 'Add to my cart';
    const btn = /** @type {HTMLButtonElement | null} */ (document.querySelector('[data-cart-share-add]'));
    if (btn) {
      btn.disabled = true;
      btn.textContent = addingLabel;
    }
    if (textEl) textEl.textContent = '';
    fetch(addUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items }),
    })
      .then((res) => {
        return res.text().then((text) => {
          let data = null;
          try {
            data = text ? JSON.parse(text) : null;
          } catch (error) {
            console.warn('Failed to parse cart share response', error);
          }
          if (!res.ok) {
            const errMsg = (data && (data.description || data.message)) || res.statusText || 'Request failed';
            throw new Error(errMsg);
          }
          if (data && (data.status === 422 || data.status === 404)) {
            throw new Error(data.description || data.message || 'Cart error');
          }
          return data;
        });
      })
      .then(() => {
        hideBanner();
        window.location.href = getCartUrlWithoutParam();
      })
      .catch((err) => {
        if (btn) {
          btn.disabled = false;
          btn.textContent = addLabel;
        }
        if (textEl) {
          const count = items.length;
          const suffix = count === 1 ? 'item' : 'items';
          const baseMsg = banner?.dataset.sharedMessage?.replace(/\{\{\s*count\s*\}\}/g, String(count))
            || `Someone shared a cart with you (${count} ${suffix}).`;
          textEl.textContent = baseMsg + ' ' + (err && err.message ? err.message : '');
        }
      });
  }

  function init() {
    const params = new URLSearchParams(window.location.search);
    const encoded = params.get(CART_SHARE_PARAM);
    const decoded = encoded ? decodeURIComponent(encoded) : '';
    const items = parseSharedCart(decoded);
    if (items.length === 0) return;

    showBanner(items);

    const addBtn = document.querySelector('[data-cart-share-add]');
    const dismissBtn = document.querySelector('[data-cart-share-dismiss]');
    if (addBtn) {
      addBtn.addEventListener('click', () => addSharedToCart(items));
    }
    if (dismissBtn) {
      dismissBtn.addEventListener('click', () => {
        hideBanner();
        window.history.replaceState({}, '', getCartUrlWithoutParam());
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
